import axios from "http/customAxios";
import {
  ReservationEvent,
  ReservationEventCustomer,
  ReservationEventStatusInfo,
  ReservationMetadata,
  ReservationPaymentStatus,
} from "./model";
import { convertUTCToEstablishmentTime } from "../../lib/dateUtils";

const baseUrl = window?.CONFIG?.reservationEventsApiEndpoint;

export async function getReservationEventsByBookingId(
  propertyTicker: string,
  bookingId: string,
  timeZone?: string
): Promise<ReservationEvent[]> {
  const url = `${baseUrl}/reservations/events/${propertyTicker}/${bookingId}`;
  const response = await axios.get<ReservationEvent[]>(url);
  const data = response.data.map(it => {
    return {
      ...it,
      ...getCustomerPropsFromMetadata(it.metadata),
      ...getReservationEventStatusInfoFromMetadata(it.metadata),
      reservationOrigin: it.metadata.origin,
      paymentTicker: it.metadata.paymentTicker,
      eventDate: convertUTCToEstablishmentTime(it.eventDate, timeZone, "yyyy-MM-dd'T'HH:mm:ssXXX"),
    };
  });
  return data.sort(sortByCreatedAtAsc);
}

const sortByCreatedAtAsc = (before: ReservationEvent, next: ReservationEvent) => {
  return new Date(before.createdAt).getTime() - new Date(next.createdAt).getTime();
};

const getReservationEventStatusInfoFromMetadata = (
  metadata: ReservationMetadata
): ReservationEventStatusInfo => {
  let paymentStatus: ReservationPaymentStatus | undefined;
  if (
    metadata.paymentStatus === 0 ||
    metadata.paymentStatus === 2 ||
    metadata.paymentStatus === 5
  ) {
    paymentStatus = "SUCCESS";
  } else if (metadata.paymentStatus === 1) {
    paymentStatus = "NOT_COMPLETED";
  } else if (metadata.paymentStatus === 3) {
    paymentStatus = "FAILED";
  } else if (metadata.paymentStatus === 4) {
    paymentStatus = "PENDING";
  } else if (metadata.paymentStatus === 6) {
    paymentStatus = "EXPIRED";
  } else {
    throw new Error("Invalid payment status " + metadata.paymentStatus);
  }
  return {
    status: metadata.status,
    paymentStatus,
  };
};

const getCustomerPropsFromMetadata = (metadata: ReservationMetadata): ReservationEventCustomer => {
  return {
    name: metadata.customer.givenName,
    email: metadata.customer.email,
    phone: metadata.customer.telephone,
  };
};
